export default __webpack_public_path__ + "static/media/cs5.ac28f63c.jpeg";